import { apiFetch } from '../../api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { createTableSlice } from '../helpers';
import { JobType } from '../../constants';

export const tableSlice = createTableSlice({
  name: 'dataCurationDashboard/stagedForSplittingTable',
  url: '/api/sequenceIntervals/unstaged',
});

function splitSequence(sequenceInterval) {
  return apiFetch('/api/jobs', 'POST', {
    sequence_interval_id: sequenceInterval.id,
    type: JobType.SEQUENCE_SPLIT,
  });
}

export const splitSequences = createAsyncThunk(
  'dataCurationDashboard/stagedForSplitting/splitSequences',
  async function (_, { getState, dispatch }) {
    try {
      const state = getState();
      const rawSequenceIds = tableSlice.selectors.selectSelectedRows(state);
      const rowsById = tableSlice.selectors.selectRowsById(state);
      const sequenceIntervals = rawSequenceIds.flatMap((id) => rowsById[id].sequence_intervals);

      let requests = sequenceIntervals.map(splitSequence);
      await Promise.all(requests);
      await dispatch(tableSlice.actions.clearSelection());
      await dispatch(tableSlice.actions.fetchRows());
    } catch (e) {
      console.error(e);
    }
  }
);

export const enableSplitSequencesButton = (state) =>
  tableSlice.selectors.selectSelectedRows(state).length > 0;
